import { render, staticRenderFns } from "./detailsInventorySurplus.vue?vue&type=template&id=70a22c4f&scoped=true"
import script from "./detailsInventorySurplus.vue?vue&type=script&lang=js"
export * from "./detailsInventorySurplus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a22c4f",
  null
  
)

export default component.exports